<template>
  <v-radio-group v-bind="this.$attrs" @change="$emit('change', type)" v-model="type" row class="shrink mt-0 pt-0">
    <v-row style="width: 100%">
      <v-col cols="12" sm="3">
        <v-radio label="Đúng giờ" hide-details value="present"></v-radio>
      </v-col>
      <v-col cols="12" sm="3">
        <v-radio label="Đi muộn" hide-details value="invalidPresent"></v-radio>
      </v-col>
    </v-row>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: ''
  }),
  props: {
    item: {
      type: Object
    }
  },
  created() {
    if (this.item) {
      this.type = this.item.status
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.type = newVal.status
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
